/** @jsx jsx */
import { jsx } from '@emotion/react';

import { kebabCase } from 'lodash';

import { Button } from 'bundles/enterprise-ui/components/Button';

import _t from 'i18n!nls/enterprise-admin-users';

type Props = {
  onContinue: () => void;
  onCancel: () => void;
  disabled: boolean;
  onContinueLabel: string;
  onPrevious?: () => void;
};

const ModalFooter = ({ onContinue, onPrevious, disabled, onContinueLabel, onCancel }: Props) => {
  return (
    <div css={{ display: 'flex', gap: 'var(--cds-spacing-200)', marginTop: 'var(--cds-spacing-300)' }}>
      <Button
        onClick={onContinue}
        disabled={disabled}
        variant="primary"
        data-e2e={`modal-${kebabCase(onContinueLabel)}`}
      >
        {onContinueLabel}
      </Button>
      <Button onClick={onCancel} variant="secondary" type="button">
        {_t('Cancel')}
      </Button>
      {onPrevious && (
        <Button variant="ghost" onClick={onPrevious} type="button">
          {_t('Back')}
        </Button>
      )}
    </div>
  );
};
export default ModalFooter;
